export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 64;
export const CAPITAL_LETTER_REGEX = /^.*[A-Z]/;
export const NUMBER_REGEX = /^.*\d/;
export const SPECIAL_CHAR_REGEX = /^.*[!@#$%^&*()_+\-=\[\]{}|;':",.<>?/`~]/;